export const table = {
    slots: {
        thead: 'bg-muted',
        th: 'py-2 h-12 text-xs text-neutral-500',
        td: 'py-3',
    },
}
